import { DetailedHTMLProps, SelectHTMLAttributes } from "react";
import Select, { components } from "react-select";

interface ISelectHookFormSingle
  extends DetailedHTMLProps<
    SelectHTMLAttributes<HTMLSelectElement>,
    HTMLSelectElement
  > {
  field?: any;
  options: any;
  isDisabled?: boolean;
  className?: string;
  label?: string;
  validation?: any;
  onChange?: any;
  onInputChange?: (inputValue: string) => void;
  value?: any;
  isClearable?: boolean;
  defaultValue?: any;
  isLoading?: boolean;
  labelClassName?: string;
  secondDiv?: string;
  selectClass?: string;
  placeHolder?: string;
}
const SelectHookFormSingle: React.FC<ISelectHookFormSingle> = ({
  field,
  options,
  className,
  label,
  onChange, // send value to hook form
  onInputChange,
  value,
  defaultValue,
  isLoading,
  secondDiv = "grid md:grid-cols-3 items-center",
  isClearable = true,
  isDisabled = false,
  required = false,
  placeHolder,
}) => {
  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      background: isDisabled ? "#FAFAFA" : "#ffffff",
      border: "0px",
      borderColor: "#edebeb",
      minHeight: "26px",
      height: "6px",
      boxShadow: state.isFocused ? null : null,
      fontSize: "12px",
    }),
    option: (provided, state) => ({
      ...provided,
      active: "",
      //  padding: "3px",
      color: state.isSelected ? "white" : "black",
      fontSize: "12px",
    }),
    menu: (provided, state) => ({
      ...provided,
      //overflowX: "auto",
      //padding: "0px 6px",
      minHeight: "auto",
      maxHeight: "auto",
      zIndex: "10px",
    }),
    // placeholder: (provided, state) => ({
    //   ...provided,
    //   overflowX: "auto",
    //   marginLeft: "0px ",
    //   marginRight: "-3px",
    // }),

    valueContainer: (provided, state) => ({
      ...provided,
      height: "26px",
      // padding: "0px 6px",
      fontSize: "12px",
    }),

    input: (provided, state) => ({
      ...provided,
      // margin: "0px",
      fontSize: "12px",
    }),
    // indicatorSeparator: (state) => ({
    //   display: "none",
    // }),
    indicatorsContainer: (provided, state) => ({
      ...provided,
      height: "28px",
      margin: "0px",
    }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  };

  return (
    <div className="space-y-1 w-full text-xs">
      <div className={`${secondDiv}`}>
        {label && (
          <label
            className={`flex items-stretch text-left expandedLabel fontExpand`}
          >
            {required && (
              <span className="text-red-500 font-bold self-start pr-0.5">
                *
              </span>
            )}{" "}
            {label}:{" "}
          </label>
        )}

        <Select
          {...field}
          className={`${
            className ? className : "border border-gray-300 col-span-2"
          } w-full rounded-sm text-xs focus:ring-quaternary focus:border-quaternary${
            isDisabled && "opacity-50 "
          }`}
          components={components}
          menuPortalTarget={document.body}
          styles={customStyles}
          isLoading={isLoading}
          options={options}
          onChange={onChange}
          onInputChange={(inputValue, { action }) => {
            if (action === "input-change") {
              onInputChange?.(inputValue);
            }
          }}
          isSearchable
          isDisabled={isDisabled}
          isClearable={isClearable}
          defaultValue={defaultValue}
          value={
            value || value === false
              ? options?.find((c) => c.value === value)
              : null
          }
          isMulti={false}
          tabSelectsValue={false}
          // placeholder={
          //   !options.find((c) => c.value === value) && value
          //     ? value
          //    : placeHolder
          // }
          placeholder={placeHolder}
        />
      </div>
    </div>
  );
};

export default SelectHookFormSingle;
